import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTranslation,
} from "@ncino/pax-ui";

export function InstitutionChangedModal({ open }: { open: boolean }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} aria-labelledby="institution-changed-title">
      <DialogTitle id="institution-changed-title">{t("institutionChanged.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("institutionChanged.warning")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => window.location.reload()}>
          {t("institutionChanged.reload")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
